import type { CellContext } from '@tanstack/react-table'

import type { Document } from '@/modules/documents'

export const NumberOfPagesCell = (cell: CellContext<Document, string>) => (
  <div className="text-left">{cell.getValue()}</div>
)
